<script>
import moment from "moment";
import {mapGetters} from "vuex";
import {getUserServiceList} from "@/api/subscriptions";

export default {
  name: 'Subscriptions',
  data() {
    let ready = false
    let active_services = []
    let awaiting_services = []
    getUserServiceList().then(
        (response) => {
          this.active_services = response.data.active_services
          this.awaiting_services = response.data.awaiting_services
          this.ready = true
        }
    )

    return {
      ready,
      active_services,
      awaiting_services
    }
  },
  computed: {
    moment() {
      return moment
    },
    ...mapGetters('subscription', [
      'getUserServicesList'
    ]),
  },
}
</script>

<template>
  <div class="ais24--subscription">
    <div class="ais24--container" v-if="ready">
      <header class="ais24--header">
        <h2 class="ais24--title">Ваша подписка</h2>
      </header><!--/.ais24--header-->
      <div class="ais24--new-subscription"  v-if="active_services.length === 0 && awaiting_services.length === 0">
        <h3 class="ais24--new-subscription__title">Новая подписка</h3>
        <div class="ais24--new-subscription__text">
          <p>У&nbsp;вас нет активных подписок. Нажмите кнопку &laquo;Приобрести новую подписку&raquo;,
            <br>и&nbsp;перейдите к&nbsp;настройке новой подписки.
          </p>
        </div>
        <div class="ais24--new-subscription__action">
          <router-link :to="{name: 'SubscriptionPage'}"  class="ais24--button ais24--button--primary ais24--button--large">
            <span class="ais24--button__text">Приобрести новую подписку</span>
          </router-link>
        </div>
      </div><!--/.ais24--new-subscription-->
      <div v-else>
        <div class="ais24--new-subscription__action">
          <router-link :to="{name: 'SubscriptionPage'}"  class="ais24--button ais24--button--primary ais24--button--large">
            <span class="ais24--button__text">Приобрести новую подписку</span>
          </router-link>
        </div>
      </div>
      <hr class="ais-24--spacer ais-24--spacer--48">
      <div class="ais24--my-subscriptions">
        <div class="ais24--my-subscriptions__section" v-if="active_services.length > 0">
          <div class="ais24--my-subscriptions__headline">
            <h4 class="ais24--my-subscriptions__title">Активные сервисы</h4>
            <div class="ais24--my-subscriptions__caption">Вы&nbsp;можете поменять конфигурацию активных сервисов подписки с&nbsp;помощью кнопки &laquo;Настроить&raquo;</div>
          </div><!--/.ais24--my-subscriptions__headline-->
          <div class="ais24--my-subscriptions__content">
            <div class="ais24--services">
              <ul class="ais24--services__list">
                <li class="ais24--services__item" v-for="service in active_services" v-bind:key="service.id">
                  <div class="ais24--service-card">
                    <div class="ais24--service-card__header">
                      <div class="ais24--service-card-preview">
                        <div class="ais24--service-card-preview__headline">
                          <h3 class="ais24--service-card-preview__title">Сервис &laquo;{{service.service.name}}&raquo;</h3>
                          <p class="ais24--service-card-preview__caption">{{ service.period }} месяца, {{ service.unit_count }} места организации</p>
                        </div>
                        <div class="ais24--service-card-preview__status">
                          <div class="ais24--service-card-preview__label">
                            <span class="ais24--label ais24--label--success">Активен</span>
                          </div>
                          <div class="ais24--service-card-preview__details">Активен до {{ moment(service.subscription_finish_date, 'YYYY-MM-DD').format('DD.MM.Y') }}</div>
                        </div>
                        <div class="ais24--service-card-preview__actions">
                          <router-link :to="{name: 'SubscriptionSettingsPage', params: {id: service.id}}" class="ais24--button ais24--button--default ais24--button--medium" >
                            <span class="ais24--button__text">Настроить</span>
                          </router-link>
                        </div>
                      </div>
                    </div>
                  </div><!--/.ais24--service-card-->
                </li><!--/.ais24--services__item-->
              </ul><!--/.ais24--services__list-->
            </div><!--/.ais24--services-->
          </div><!--/.ais24--my-subscriptions__content-->
        </div><!--/.ais24--my-subscriptions__section-->
        <div class="ais24--my-subscriptions__section" v-if="awaiting_services.length > 0">
          <div class="ais24--my-subscriptions__headline">
            <h4 class="ais24--my-subscriptions__title">В ожидании</h4>
            <div class="ais24--my-subscriptions__caption">Приобретенные подписки на&nbsp;сервисы начнут действовать сразу после окончания активной подписки</div>
          </div><!--/.ais24--my-subscriptions__headline-->
          <div class="ais24--my-subscriptions__content">
            <div class="ais24--services">
              <ul class="ais24--services__list">
                <li class="ais24--services__item" v-for="service in awaiting_services" v-bind:key="service.id">
                  <div class="ais24--service-card">
                    <div class="ais24--service-card__header">
                      <div class="ais24--service-card-preview">
                        <div class="ais24--service-card-preview__headline">
                          <h3 class="ais24--service-card-preview__title">Сервис &laquo;{{service.service.name}}&raquo;</h3>
                          <p class="ais24--service-card-preview__caption">{{ service.period }} месяца, {{ service.unit_count }} места организации</p>
                        </div>
                        <div class="ais24--service-card-preview__status">
                          <div class="ais24--service-card-preview__label">
                            <span class="ais24--label ais24--label--warning">В ожидании</span>
                          </div>
                          <div class="ais24--service-card-preview__details">Начнет действовать с {{ moment(service.subscription_start_date, 'YYYY-MM-DD').format('DD.MM.Y')  }}</div>
                        </div>
<!--                        <div class="ais24&#45;&#45;service-card-preview__actions">-->
<!--                          <a class="ais24&#45;&#45;button ais24&#45;&#45;button&#45;&#45;default ais24&#45;&#45;button&#45;&#45;medium" href="#" data-disabled>-->
<!--                            <span class="ais24&#45;&#45;button__text">Настроить</span>-->
<!--                          </a>-->
<!--                        </div>  -->
                      </div>
                    </div>
                  </div><!--/.ais24--service-card-->
                </li><!--/.ais24--services__item-->
              </ul><!--/.ais24--services__list-->
            </div><!--/.ais24--services-->
          </div><!--/.ais24--my-subscriptions__content-->
        </div><!--/.ais24--my-subscriptions__section-->
      </div><!--/.ais24--my-subscriptions-->
    </div><!--/.ais24--container-->
    <div v-else>
      <div class="ais24--container">
      Загрузка данных...
      </div>
    </div>
  </div><!--/.ais24--subscription-->

</template>

<style scoped lang="scss">

</style>
